export default __webpack_public_path__ + "static/media/breaking-bad.4a98a03d.jpg";